import {connectRouter, routerMiddleware} from 'connected-react-router';
import {applyMiddleware, combineReducers, compose, createStore} from 'redux';
import createSagaMiddleware, {SagaMiddleware} from 'redux-saga';
import thunk from 'redux-thunk';
import {activateAuthInterceptor} from '../../modules/auth/services/AuthService';
import reducers from '../reducers';
import {rootSagas} from '../sagas/RootSagas';

const createBrowserHistory = require('history').createBrowserHistory;
const history = createBrowserHistory();
const rootReducer = combineReducers({
  ...reducers,
  router: connectRouter(history),
});

export type AppState = ReturnType<typeof rootReducer>;

export default function configureStore(initialState?: AppState) {
  // Configure the middleware

  const sagaMiddleware: SagaMiddleware = createSagaMiddleware();
  const middleware = [sagaMiddleware, thunk, routerMiddleware(history)];
  const enhancers: any[] = [];
  const windowIfDefined = typeof window === 'undefined' ? null : (window as any);

  // Utilise le compose de DevTools s'il existe, sinon le compose de Redux
  const composeEnhancers =
    windowIfDefined?.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__?.({
      // Limite la taille des actions/state loggés
      maxAge: 25, // garde seulement les 25 dernières actions
      serialize: {
        options: {
          undefined: true,
          function: false,
        },
      },
      // Ignore les actions trop lourdes
      actionsBlacklist: [], // tu pourras ajouter des types d'actions ici
      stateSanitizer: (state: any) => ({
        ...state,
      }),
    }) ?? compose;
  const store = createStore(rootReducer, initialState, composeEnhancers(applyMiddleware(...middleware)));
  activateAuthInterceptor(store);

  // Activate the sagas (need to be done after store creation)
  sagaMiddleware.run(rootSagas);

  return store;
}

export {history};

// export type AppState = ReturnType<typeof rootReducer>;
